
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.429 6H5a1 1 0 010-2h3.857l.336-.532A.849.849 0 019.957 3h4.082c.325 0 .622.18.768.468l.336.532H19a1 1 0 110 2H5.429zM19 19.313V7.421A.427.427 0 0018.571 7H5.43A.427.427 0 005 7.422v11.89C5 20.244 5.696 21 6.643 21h10.643c.946 0 1.714-.756 1.714-1.688zM8.5 10c.314 0 .5.253.5.563v7.874c0 .31-.186.563-.5.563s-.5-.253-.5-.563v-7.875c0-.309.186-.562.5-.562zm3.5 0c.314 0 .5.253.5.563v7.874c0 .31-.186.563-.5.563s-.5-.253-.5-.563v-7.875c0-.309.186-.562.5-.562zm3.5 0c.314 0 .5.253.5.563v7.874c0 .31-.186.563-.5.563s-.5-.253-.5-.563v-7.875c0-.309.186-.562.5-.562z"}})])
          )
        }
      }
    